import CrudTable from "@/components/admin/CrudTable";

export default function AdminBlog() {
  return (
    <CrudTable
      title="Blog Posts"
      testid="admin-blog"
      endpoint="/admin/blog"
      adminEndpoint="/admin/blog"
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "author", label: "Author" },
        { key: "published", label: "Live", render: (r) => (r.published ? "✓" : "—") },
      ]}
      defaults={{ slug: "", title: "", category: "", excerpt: "", content: "", cover_image: "", author: "MIA Editorial", published: true }}
      fields={[
        { name: "slug", label: "Slug (URL)" },
        { name: "title", label: "Title" },
        { name: "category", label: "Category" },
        { name: "author", label: "Author" },
        { name: "cover_image", label: "Cover Image URL" },
        { name: "excerpt", label: "Excerpt", type: "textarea", rows: 3 },
        { name: "content", label: "Full Content", type: "textarea", rows: 10 },
        { name: "published", label: "Published", type: "checkbox" },
      ]}
    />
  );
}
